var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6694_26149)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6694_26149",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4012 32.3948V1.59489H1.6013V32.3948H32.4012Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.86667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6694_26149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2145 10.6203C20.2189 11.3305 20.7984 11.9028 21.5088 11.8984L22.2113 11.8941C22.9221 11.8897 23.4946 11.31 23.4898 10.5994L23.4897 10.5919C23.4884 10.3924 23.4406 10.1958 23.3501 10.0179C23.2596 9.84 23.129 9.68559 22.9685 9.5669L20.7302 7.91099C20.5685 7.79142 20.4372 7.63562 20.3467 7.4561C20.2562 7.27657 20.209 7.07832 20.209 6.87727C20.209 6.16702 20.7849 5.59128 21.4954 5.59128H22.199C22.9094 5.59128 23.4854 6.16702 23.4854 6.87727",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8496 5.60156V4.68275",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8496 12.8125V11.8937",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9734 8.74313C28.9734 12.6776 25.7828 15.8672 21.8471 15.8672C17.9112 15.8672 14.7207 12.6776 14.7207 8.74313C14.7207 4.80866 17.9112 1.61908 21.8471 1.61908C25.7828 1.61908 28.9734 4.80866 28.9734 8.74313Z",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82379 32.375L1.62891 23.0304L6.90934 21.2262L10.1042 30.5709L4.82379 32.375Z",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1923 22.3275L28.9751 19.1278C29.3387 18.8731 29.7719 18.7365 30.2159 18.7367C30.8636 18.7367 31.5031 19.0264 31.9289 19.5744C32.6851 20.5474 32.4777 21.9542 31.4738 22.6688L25.1554 27.163C23.4647 28.3662 21.4411 29.0127 19.366 29.0126L9.67773 29.3125",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7461 24.2266H22.1458C22.4139 24.227 22.6795 24.1744 22.9272 24.0717C23.1749 23.9691 23.3998 23.8185 23.5891 23.6286C23.9586 23.2592 24.1872 22.749 24.1872 22.1857C24.1872 21.0585 23.2733 20.1449 22.1458 20.1449H19.1544",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15625 21.6719C10.1576 19.6309 12.2568 18.2259 14.6839 18.2259C16.4468 18.2259 18.0359 18.9667 19.1573 20.154",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15595 21.6584L7.42188 22.7188",
    stroke: "#0B8080",
    strokeWidth: 1.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6694_26149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6667,
    height: 32.6667,
    fill: "white",
    transform: "translate(0.667969 0.671875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverall);
export default __webpack_public_path__ + "static/media/overall.9e36c099f874d304cf18aec0956bcd84.svg";
export { ForwardRef as ReactComponent };